import {
  createStyles,
  Grid,
  Theme,
  Typography,
  withStyles,
  WithStyles,
  Button,
  Hidden,
  IconButton,
  Link as HREFLink,
} from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import React from 'react';
import { WandSparkles } from 'lucide-react';
import { Link, withRouter, RouteComponentProps } from 'react-router-dom';
const logo = 'https://www.app.aisensy.com/static/media/full_logo.5c8cd2004689fd2d18de.png';

const NavbarDesktop = (props: Props): React.ReactElement => {
  const { classes } = props;
  const path = props.location.pathname;
  return (
    <div
      style={{ height: 100, width:'100%',display:'flex',alignItems:'center',justifyContent:'center' }}
    >
      <div style={{maxWidth:'1113px',justifyContent: 'space-between',display:'flex',alignItems:'center',width:'100%',marginRight:'55px'}}>
      <div >
        <Link
          to={path === '/' ? '/generate-ads' : '/'}
          style={{ display: 'block', height: '34px' }}
        >
          <img src={logo} className={classes.logo} />
        </Link>
      </div>
      {/* <Grid item>
        <Button
          style={{
            borderRadius: 25,
            marginRight: 20,
            color: 'black',
            fontFamily: 'Poppins',
          }}
          href="https://m.aisensy.com/pricing"
          target="_blank"
        >
          Pricing
        </Button>
      </Grid>
      <Grid item>
        <Button
          style={{
            borderRadius: 25,
            marginRight: 20,
            color: 'black',
            fontFamily: 'Poppins',
          }}
          href="https://aisensy.com/"
          target="_blank"
        >
          Platform
        </Button>
      </Grid>
      <Grid item>
        <ActiveBtn path={path} />
      </Grid>
      <Grid item xs>
        <Button
          style={{
            borderRadius: 25,
            marginRight: 20,
            color: 'black',
            fontFamily: 'Poppins',
          }}
          href="https://aisensy.com/integrations"
          target="_blank"
        >
          Integrations
        </Button>
      </Grid> */}
      {/* <div > */}
        <Button
          // style={{
          //   borderRadius: 25,
          //   color: 'black',
          //   fontFamily: 'Inter, sans-serif',
          //   marginRight: 20,
          //   fontSize: 16,
          // }}
          className={classes.switchBtn}
          style={{margin:0}}
          // className={classes.rightMargin}
          component={Link}
          to={path === '/' ? '/generate-template' : '/'}
          startIcon={<WandSparkles size={20} />}
        >
          {path === '/'
            ? 'Try Our AI Template Generator'
            : 'Try Our AI Ad Creative Generator'}
        </Button>
      {/* </div> */}
    </div>
    </div>
  );
};
const ActiveBtn = (props: { path: string }): React.ReactElement => {
  switch (props.path) {
    case '/generate-whatsapp-link':
      return (
        <Button
          style={{ borderRadius: 25, marginRight: 20 }}
          component={Link}
          to="/generate-whatsapp-button"
        >
          WhatsApp Button
        </Button>
      );
    case '/generate-whatsapp-button':
      return (
        <Button
          style={{ borderRadius: 25, marginRight: 20 }}
          component={Link}
          to="/generate-whatsapp-link"
        >
          WhatsApp Link
        </Button>
      );
    default:
      return (
        <Button
          style={{ borderRadius: 25, marginRight: 20 }}
          href="https://help.aisensy.com/"
          target="_blank"
        >
          Resources
        </Button>
      );
  }
};
interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  // name: string,
  // number: string
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: 60,
      width: '100vw',
      position: 'sticky',
      top: 0,
      left: 0,
      backgroundColor: '#EBF5F3',
      // backgroundColor: "#ffffff",
      // boxShadow: 'rgb(0 0 0 /10%) 0px 0px 0.428571rem 0px',
      // backgroundColor: theme.palette.primary.main,
      // paddingLeft: theme.spacing(2),
      boxSizing: 'border-box',
      zIndex: 100,
      // color: "white"
      // boxShadow: "0px 0px 2px 2px lightgrey"
    },
    logo: {
      height: 50,
      // marginRight: 50,
      [theme.breakpoints.down('md')]: {
        marginRight: 20,
        // width: 60,
        height: 40,
        marginLeft: 10,
      },
    },
    rightMargin: {
      [theme.breakpoints.down('lg')]: {
        marginRight: 140,
      },
      [theme.breakpoints.down('md')]: {
        marginRight: 160,
      },
      [theme.breakpoints.up('lg')]: {
        marginRight: 200,
      },
      [theme.breakpoints.down('sm')]: {
        marginRight: 10,
      },
    },
    switchBtn: {
      background: 'linear-gradient(45deg,#9152f7,#685ef3,#5d06e8)',
      backgroundSize: '300% 300%',
      color: 'white',
      fontWeight: 600,
      padding: '10px 20px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      fontSize: '20px',
      textDecoration: 'none',
      marginRight: 50,
      animation: '$gradient 3s ease infinite',
      position: 'relative',
      overflow: 'hidden',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-100%',
        width: '100%',
        height: '100%',
        background:
          'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
        animation: '$shine 1.2s linear infinite',
      },
      '&:hover': {
        background: 'linear-gradient(45deg, #3730A3, #6D28D9, #3730A3)',
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
      },
    },
    '@global': {
      '@keyframes gradient': {
        '0%': {
          backgroundPosition: '0% 50%',
        },
        '50%': {
          backgroundPosition: '100% 50%',
        },
        '100%': {
          backgroundPosition: '0% 50%',
        },
      },
      '@keyframes shine': {
        '0%': {
          left: '-100%',
        },
        '100%': {
          left: '100%',
        },
      },
    },
  });

export default withStyles(styles)(withRouter(NavbarDesktop));
